// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fP22","colBig":"styles_colBig__1zfuy","colSmall":"styles_colSmall__16Cri"};